import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { useAuth } from 'context/auth-context';

import ProgramCalendar from './components/ProgramCalendar';
import ProgramsPageHeader from './components/ProgramsPageHeader';
import { FilterTerms } from './components/types';

const Program = (): JSX.Element => {
  const initialSearchFiltersValue = {
    kiloClassTypes: [],
  };
  const { hasPerm } = useAuth();

  const programmingPerm = hasPerm('ProgramMutate');

  const [searchFilters, setSearchFilters] = useState<FilterTerms>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<FilterTerms>(searchFilters, 250);

  return (
    <>
      <ProgramsPageHeader
        setSearchFilters={setSearchFilters}
        initialSearchFiltersValue={initialSearchFiltersValue}
      />
      <ProgramCalendar searchFilters={debouncedSearchFilters} permission={programmingPerm} />
    </>
  );
};

export default Program;
